import { executeCtaHandler } from '#pplx/frontend/apps/ask/hooks/upsells-hooks/handlers/executeCtaHandler.js';
import { composeUpsellActionRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/composeUpsellActionRuntime.js';
import { useUpsellActionBaseRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/useUpsellActionBaseRuntime.js';
import { useUpsellActionCometRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/useUpsellActionCometRuntime.js';
import { useUpsellActionConnectorRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/useUpsellActionConnectorRuntime.js';
import { useUpsellActionContentRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/useUpsellActionContentRuntime.js';
import { useUpsellActionHealthRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/useUpsellActionHealthRuntime.js';
import { useUpsellActionSubscriptionRuntime } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/useUpsellActionSubscriptionRuntime.js';
import { useExecuteUpsellSlotAction } from '#pplx/frontend/apps/ask/upsell-slots/actions/useExecuteUpsellSlotAction.js';
import { useMemo } from 'react';
export const useHomepageTopBannerUpsellAction = ({ inFlight, options, upsellInformation, }) => {
    const baseRuntime = useUpsellActionBaseRuntime({
        executeCtaHandler,
        hideUpsell: options?.hideUpsell,
        upsellInformation,
    });
    const cometRuntime = useUpsellActionCometRuntime();
    const connectorRuntime = useUpsellActionConnectorRuntime({
        $t: baseRuntime.$t,
        hideUpsell: baseRuntime.hideUpsell,
        lastResult: baseRuntime.lastResult,
        openToast: baseRuntime.openToast,
        retryQueryParam: baseRuntime.retryQueryParam,
        router: baseRuntime.router,
        upsellInformation,
    });
    const contentRuntime = useUpsellActionContentRuntime({
        firstResult: baseRuntime.firstResult,
        origin: baseRuntime.origin,
    });
    const healthRuntime = useUpsellActionHealthRuntime({
        $t: baseRuntime.$t,
        hideUpsell: baseRuntime.hideUpsell,
        openToast: baseRuntime.openToast,
    });
    const subscriptionRuntime = useUpsellActionSubscriptionRuntime();
    const runtime = useMemo(() => composeUpsellActionRuntime({
        baseRuntime,
        cometRuntime,
        connectorRuntime,
        contentRuntime,
        healthRuntime,
        subscriptionRuntime,
    }), [
        baseRuntime,
        cometRuntime,
        connectorRuntime,
        contentRuntime,
        healthRuntime,
        subscriptionRuntime,
    ]);
    return useExecuteUpsellSlotAction({
        inFlight,
        options,
        runtime,
        upsellInformation,
    });
};
//# sourceMappingURL=useHomepageTopBannerUpsellAction.js.map